export default __webpack_public_path__ + "static/media/Bloodhammer.2d4b9492.jpg";